var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5, _path8, _circle6, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTonsOfRewards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 110,
    viewBox: "0 0 96 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.0514,
    cy: 27.6149,
    r: 18.5446,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4925 20.3286C63.225 20.3286 59.7656 23.7879 59.7656 28.0555C59.7656 32.3231 63.225 35.7824 67.4925 35.7824C71.7601 35.7824 75.2194 32.3231 75.2194 28.0555C75.2194 23.7879 71.7601 20.3286 67.4925 20.3286ZM67.4925 21.874C70.9063 21.874 73.6741 24.6418 73.6741 28.0555C73.6741 31.4693 70.9063 34.237 67.4925 34.237C64.0788 34.237 61.311 31.4693 61.311 28.0555C61.311 24.6418 64.0788 21.874 67.4925 21.874Z",
    fill: "#FFDF03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6414 23.1323L67.5771 23.3507V29.6862L67.6414 29.7503L70.5823 28.0119L67.6414 23.1323Z",
    fill: "#FFDF03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6411 23.1323L64.7002 28.0119L67.6411 29.7503V26.6752V23.1323Z",
    fill: "#FFDF03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6407 30.3072L67.6045 30.3513V32.6081L67.6407 32.7139L70.5833 28.5697L67.6407 30.3072Z",
    fill: "#FFDF03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6411 32.7139V30.3072L64.7002 28.5697L67.6411 32.7139Z",
    fill: "#FFDF03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6416 29.7503L70.5824 28.012L67.6416 26.6753V29.7503Z",
    fill: "#FFDF03"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7002 28.012L67.641 29.7503V26.6753L64.7002 28.012Z",
    fill: "#FFDF03"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.9968,
    cy: 65.7038,
    r: 13.5994,
    fill: "#B6B0FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.8026,
    cy: 19.0662,
    r: 9.06623,
    fill: "#B6B0FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1656,
    cy: 93.3658,
    r: 8.49959,
    fill: "#B6B0FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.4526,
    cy: 101.547,
    r: 21.5473,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1488 97.1233H59.1916C59.2903 96.845 59.3532 96.5398 59.3532 96.2255C59.3532 94.7352 58.1501 93.5321 56.6597 93.5321C55.717 93.5321 54.9 94.0169 54.4152 94.7441L53.9663 95.3457L53.5174 94.7352C53.0326 94.0169 52.2156 93.5321 51.2729 93.5321C49.7826 93.5321 48.5795 94.7352 48.5795 96.2255C48.5795 96.5398 48.6423 96.845 48.7411 97.1233H46.7839C45.7873 97.1233 44.9973 97.9224 44.9973 98.9189L44.9883 108.795C44.9883 109.791 45.7873 110.59 46.7839 110.59H61.1488C62.1453 110.59 62.9444 109.791 62.9444 108.795V98.9189C62.9444 97.9224 62.1453 97.1233 61.1488 97.1233ZM56.6599 95.3277C57.1537 95.3277 57.5577 95.7317 57.5577 96.2255C57.5577 96.7193 57.1537 97.1233 56.6599 97.1233C56.1661 97.1233 55.7621 96.7193 55.7621 96.2255C55.7621 95.7317 56.1661 95.3277 56.6599 95.3277ZM52.1705 96.2255C52.1705 95.7317 51.7664 95.3277 51.2727 95.3277C50.7789 95.3277 50.3748 95.7317 50.3748 96.2255C50.3748 96.7193 50.7789 97.1233 51.2727 97.1233C51.7664 97.1233 52.1705 96.7193 52.1705 96.2255ZM61.1489 106.999V108.795H46.784V106.999H61.1489ZM46.784 98.9189V104.306H61.1489V98.9189H56.5881L58.4555 101.46L57.001 102.51L53.9665 98.3802L50.9319 102.51L49.4774 101.46L51.3449 98.9189H46.784Z",
    fill: "#FFDF03"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7261,
    cy: 56.0499,
    r: 24.7261,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3143 46.3354C23.6242 46.3354 19.0117 50.9479 19.0117 56.638C19.0117 62.3281 23.6242 66.9405 29.3143 66.9405C35.0044 66.9405 39.6168 62.3281 39.6168 56.638C39.6168 50.9479 35.0044 46.3354 29.3143 46.3354ZM29.3143 48.396C33.8659 48.396 37.5563 52.0863 37.5563 56.638C37.5563 61.1897 33.8659 64.88 29.3143 64.88C24.7626 64.88 21.0722 61.1897 21.0722 56.638C21.0722 52.0863 24.7626 48.396 29.3143 48.396ZM28.6885 49.557V51.5109H26.5334V61.7651H28.6885V63.6667H30.0266V61.7591C31.0125 61.7426 31.7769 61.4949 32.3064 61.0045C32.8525 60.4976 33.1254 59.746 33.1254 58.7508C33.1254 58.5025 33.1004 58.2583 33.0489 58.0224C32.9964 57.7854 32.9137 57.5643 32.8014 57.3624C32.6891 57.1605 32.5401 56.9847 32.3567 56.8312C32.1733 56.6797 31.9504 56.5643 31.6887 56.4891C31.9143 56.3902 32.1075 56.2653 32.2682 56.1128C32.431 55.9614 32.5655 55.7902 32.6726 55.6017C32.7777 55.4132 32.8556 55.2124 32.9041 54.996C32.9545 54.7797 32.9785 54.5558 32.9785 54.3219C32.9785 53.8429 32.9045 53.4267 32.7572 53.0744C32.6078 52.722 32.3925 52.4309 32.1112 52.197C31.83 51.9652 31.4869 51.7922 31.081 51.6799C30.7647 51.5923 30.4057 51.5486 30.0266 51.529V49.557H28.6885ZM28.6039 53.2353H29.7026C30.125 53.2353 30.4296 53.3372 30.6182 53.5392C30.8067 53.7411 30.8999 54.0746 30.8999 54.5392C30.8999 54.9524 30.7989 55.2657 30.6001 55.479C30.4002 55.6932 30.0946 55.8009 29.6805 55.8009H28.6039V53.2353ZM28.6039 57.3081H29.9984C30.3837 57.3081 30.6587 57.4349 30.8194 57.6884C30.9822 57.9418 31.0629 58.2858 31.0629 58.7226C31.0618 58.9143 31.0407 59.0902 30.9985 59.2498C30.9562 59.4095 30.8899 59.5499 30.7993 59.6704C30.7066 59.7889 30.5903 59.8821 30.4471 59.9481C30.3029 60.013 30.1299 60.0467 29.928 60.0467H28.6039V57.3081Z",
    fill: "#FFDF03"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonsOfRewards);
export default __webpack_public_path__ + "static/media/tons-of-rewards.1517a0e955bdb7d06b932f475682ebf2.svg";
export { ForwardRef as ReactComponent };